jQuery(document).ready(function($) {

  function parsePrice(priceText) {
    if (!priceText) return NaN;

    return parseFloat(
      priceText
        .toString()
        .replace(/\s/g, '')
        .replace(/\./g, '')
        .replace(',', '.')
        .replace(/[^\d.]/g, '')
    );
  }

  function isValidPriceText(priceText) {
    if (!priceText) return false;

    var clean = priceText
      .toString()
      .replace(/\s/g, '')
      .replace('€', '')
      .trim();

    return clean !== '' && !isNaN(parsePrice(priceText));
  }

  function formatPrice(price) {
    return price.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }

  function getTextOnly($el) {
    return $.trim($el.clone().children().remove().end().text());
  }

  function saveMwstBasePrice($el) {
    var liveFormat = $.trim($el.attr('data-live-format') || '');
    var originalPrice = $.trim($el.attr('data-original-price') || '');

    var sourceText = '';

    if (isValidPriceText(liveFormat)) {
      sourceText = liveFormat;
    } else if (isValidPriceText(originalPrice)) {
      sourceText = originalPrice;
    } else if ($el.attr('data-mwst-base-text')) {
      sourceText = $el.attr('data-mwst-base-text');
    } else {
      sourceText = getTextOnly($el);
    }

    var basePrice = parsePrice(sourceText);

    if (isNaN(basePrice)) return false;

    $el.attr('data-mwst-base-text', sourceText);
    $el.attr('data-mwst-base-price', basePrice);

    return true;
  }

  function setPriceTextOnly($el, priceText) {
    var textNode = $el.contents().filter(function () {
      return this.nodeType === 3 && $.trim(this.nodeValue) !== '';
    }).first();

    if (textNode.length) {
      textNode[0].nodeValue = '\n            ' + priceText + '\n          ';
    } else {
      $el.prepend(priceText + ' ');
    }
  }

  function updateMwstPrice() {
    var isInkl = $('.price-mwSt .label.right').hasClass('active');

    $('.custom-price-inner .price-item.non-vat').each(function () {
      var $price = $(this);

      saveMwstBasePrice($price);

      var baseText = $price.attr('data-mwst-base-text');
      var basePrice = parseFloat($price.attr('data-mwst-base-price'));

      if (isNaN(basePrice)) return;

      if (isInkl) {
        setPriceTextOnly($price, formatPrice(basePrice * 1.19));
      } else {
        setPriceTextOnly($price, baseText);
      }
    });
  }

  $(document).on('change', '#mwst-toggle', function () {
    if ($(this).is(':checked')) {
      $('.price-mwSt .label').removeClass('active');
      $('.price-mwSt .label.right').addClass('active');
    } else {
      $('.price-mwSt .label').removeClass('active');
      $('.price-mwSt .label.left').addClass('active');
    }

    updateMwstPrice();
  });

  updateMwstPrice();
  setTimeout(updateMwstPrice, 300);
  setTimeout(updateMwstPrice, 1000);


  var $calculator = $('.custom-calculator-wrapper').first();

  if ($calculator.length) {
    var sectionId = $calculator.attr('id').replace('custom-calculator-', '');

    var $currentMode = $('#current_mode_' + sectionId);
    var $themeButton = $('.product-form__submit');

    var $picker = $('.custom-konfiguration-picker[data-section="' + sectionId + '"]');
    var $buttons = $picker.find('.custom-konfiguration-btn');

    function updateModeText(mode) {
      $('.text-meterware').hide();
      $('.text-rahmenprofil').hide();

      if (mode === 'Frame') {
        $('.text-rahmenprofil').show();
      }

      if (mode === 'Meter') {
        $('.text-meterware').show();
      }
    }

    function isFrameActiveNow() {
      var activeMode = $buttons.filter('.is-active').data('mode');
      var currentMode = $currentMode.val();

      return activeMode === 'Frame' || currentMode === 'Frame';
    }

    function syncClPoWrapperByActiveMode() {
      if (isFrameActiveNow()) {
        $('.cl-po--wrapper').show();
      } else {
        $('.cl-po--wrapper').hide();
      }
    }

    function setKonfigurationMode(mode) {
      $currentMode.val(mode);

      $buttons.removeClass('is-active');
      $buttons.filter('[data-mode="' + mode + '"]').addClass('is-active');

      updateModeText(mode);

      if (mode === 'Frame') {
        $calculator.stop(true, true).slideDown();

        $('#frame_config_area_' + sectionId).show();
        $('.p-ausgeschlossen-wrapper').show();

        syncClPoWrapperByActiveMode();

        $themeButton.show();

        return;
      }

      if (mode === 'Meter') {
        $calculator.stop(true, true).slideUp();

        $('#frame_config_area_' + sectionId).hide();
        $('.p-ausgeschlossen-wrapper').hide();

        syncClPoWrapperByActiveMode();

        $themeButton.show();

        return;
      }
    }

    $(document).on(
      'click',
      '.custom-konfiguration-picker[data-section="' + sectionId + '"] .custom-konfiguration-btn',
      function (e) {
        e.preventDefault();

        var mode = $(this).data('mode');

        setKonfigurationMode(mode);
      }
    );

    function getInitialMode() {
      var activeMode = $buttons.filter('.is-active').data('mode');
      var currentMode = $currentMode.val();

      if (activeMode) return activeMode;
      if (currentMode) return currentMode;

      if ($buttons.filter('[data-mode="Frame"]').length) {
        return 'Frame';
      }

      if ($buttons.filter('[data-mode="Meter"]').length) {
        return 'Meter';
      }

      return '';
    }

    var initialMode = getInitialMode();

    if (initialMode) {
      setKonfigurationMode(initialMode);
    }

    syncClPoWrapperByActiveMode();

    setTimeout(syncClPoWrapperByActiveMode, 300);
    setTimeout(syncClPoWrapperByActiveMode, 800);
    setTimeout(syncClPoWrapperByActiveMode, 1500);
    setTimeout(syncClPoWrapperByActiveMode, 2500);

    var clPoObserver = new MutationObserver(function () {
      syncClPoWrapperByActiveMode();
    });

    clPoObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }


  document.addEventListener('click', function(event) {
    const title = event.target.closest('.calc-label-title');

    if (!title) return;

    const col = title.closest('.calc-col-1-3');

    if (!col) return;

    col.classList.toggle('is-collapsed');
  });

});